export default __webpack_public_path__ + "static/media/logo-blue.40228893.svg";